/**
 * @fileoverview GET handler for the "/engagement/preset_email_templates/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementPresetEmailTemplatesId } from "./constants";
import type { EngagementPresetEmailTemplatesIdResult } from "./types";

export const getEngagementPresetEmailTemplatesId = reactQueryFetcherAdapter(
  engagementPresetEmailTemplatesId,
  (signal: AbortSignal, id: string): Promise<EngagementPresetEmailTemplatesIdResult> => {
    return fetch(`/engagement/preset_email_templates/${id}`, "GET", {}, { signal });
  }
);
